module.exports = __webpack_public_path__ + "static/media/logout.9d42df6d.svg";